import { useEffect } from "react";
import { createKeyboardNavigation } from "./keyboard-navigation";

export const useKeyboardNavigation = ({
  currentGroup,
  setCurrentGroup,
  selectedTab,
  setSelectedTab,
  setSelectedLabelKey,
  tabLabelKeys,
  isSmallScreen,
  editMode,
  saveButtonRef,
  cancelButtonRef,
  editButtonRef
}) => {
  const {
    handleKeyDown,
    handleGroupFocus,
    setupTabNavigation,
    focusFirstFormElement,
    focusEditButton
  } = createKeyboardNavigation({
    currentGroup,
    setCurrentGroup,
    selectedTab,
    setSelectedTab,
    setSelectedLabelKey,
    tabLabelKeys,
    isSmallScreen,
    editMode,
    saveButtonRef,
    cancelButtonRef,
    editButtonRef
  });

  useEffect(() => {
    const cleanup = setupTabNavigation(selectedTab, editMode);
    return cleanup;
  }, [selectedTab, editMode, isSmallScreen, setupTabNavigation, saveButtonRef, cancelButtonRef, editButtonRef]);

  return {
    handleKeyDown,
    handleGroupFocus,
    focusFirstFormElement,
    focusEditButton
  };
};
